// https://github.com/formatjs/formatjs/blob/main/packages/react-intl/examples/StaticTypeSafetyAndCodeSplitting/intlHelpers.tsx
import { useIntl, FormatNumberOptions } from 'react-intl'
import type { PrimitiveType } from 'intl-messageformat'
import enMessages from '../translations/en.json'
import { trimDecimals } from './numberToCurrency'

// "import type" ensures en messages aren't bundled by default
import * as sourceOfTruth from '../translations/en.json'

const DEFAULT_LOCALE = 'en'

export type LocaleMessages = typeof sourceOfTruth
export type LocaleKey = keyof LocaleMessages

export function useFormatMessage(): (
  id: LocaleKey, // only accepts valid keys, not any string
  values?: Record<string, PrimitiveType>
) => string {
  const intl = useIntl()
  return (id, values) => intl.formatMessage({ id }, values)
}

export function useFormatNumber(): (num: number, options?: FormatNumberOptions) => string {
  const intl = useIntl()
  return (
    num,
    options = {
      style: 'decimal',
      maximumFractionDigits: 2
    }
  ) => {
    const trimNumber = trimDecimals(num, 2)
    return intl.formatNumber(trimNumber, options)
  }
}

export function useFormatPercentage(): (num: number) => string {
  const intl = useIntl()
  return (num) => intl.formatNumber(num, { style: 'percent', maximumFractionDigits: 2 })
}

export const loadIntlMessages = () => {
  let locale = DEFAULT_LOCALE

  if (typeof window !== 'undefined') {
    // if available use browser preferred language
    locale = window.navigator.language.toLowerCase()
  }

  let translatedMessages: Record<string, string>
  switch (locale) {
    default:
      translatedMessages = enMessages
  }
  return { locale, messages: translatedMessages }
}
